import axios from 'axios'

export const getAllEvents = () => {
  return axios.get('/event')
}
export const getEventById = ({ eventId }) => {
  return axios.get(`/event/${eventId}`)
}

export const getFavoriteEvents = () => {
  return axios.get('/favorite/event')
}

export const addFavoriteEvent = ({ eventId }) => {
  return axios.post('/favorite/event', { id: eventId })
}

export const deleteFavoriteEvent = ({ eventId }) => {
  return axios.delete(`favorite/event?id=${eventId}`)
}
